import { useState } from "react";

const ScheduledCampaignCalendar= () => {
  const [date, setDate] = useState(new Date());

  const monthNames = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December",
  ];

  const days = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];

  const year = date.getFullYear();
  const month = date.getMonth();

  const getCalendarCells = () => {
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const prevMonthDays = new Date(year, month, 0).getDate();

    const offset = firstDay === 0 ? 6 : firstDay - 1;
    const cells = [];

    for (let i = offset - 1; i >= 0; i--) {
      cells.push({ day: prevMonthDays - i, muted: true });
    }

    for (let i = 1; i <= daysInMonth; i++) {
      cells.push({ day: i, muted: false });
    }

    while (cells.length < 42) {
      cells.push({ day: cells.length - daysInMonth - offset + 1, muted: true });
    }

    return cells;
  };

  const changeMonth = (value) => {
    setDate(new Date(year, month + value, 1));
  };

  const cells = getCalendarCells();

  return (
    <div
      className="
        h-[400px] p-4 rounded-xl
        bg-white dark:bg-slate-800
        text-slate-900 dark:text-white
        shadow-sm border border-slate-200 dark:border-slate-700
      "
    >
         {/* Header */}
      <h6 className="mb-3 text-center text-base font-medium text-slate-800 dark:text-slate-200 mt-2">
        Schedule Campaign
      </h6>
      {/* HEADER */}
      <div className="flex items-center justify-between mb-3">
        <button
          onClick={() => changeMonth(-1)}
          className="text-lg font-bold cursor-pointer"
        >
          ‹
        </button>

        <span className="font-semibold text-sm">
          {monthNames[month]} {year}
        </span>

        <button
          onClick={() => changeMonth(1)}
          className="text-lg font-bold cursor-pointer"
        >
          ›
        </button>
      </div>

      {/* DAYS */}
      <div className="flex justify-between text-xs mb-2 text-slate-500 dark:text-slate-400">
        {days.map((day) => (
          <div key={day} className="w-8 text-center font-medium">
            {day}
          </div>
        ))}
      </div>

      {/* CALENDAR GRID */}
      <div className="space-y-1">
        {[...Array(6)].map((_, row) => (
          <div key={row} className="flex justify-between">
            {cells.slice(row * 7, row * 7 + 7).map((cell, idx) => {
              const isWeekend = idx === 5 || idx === 6;

              return (
                <div
                  key={idx}
                  className={`
                    w-8 h-9 flex items-center justify-center
                    text-xs font-medium rounded-md cursor-pointer
                    transition
                    ${cell.muted ? "opacity-40" : ""}
                    ${
                      isWeekend
                        ? "text-cyan-400"
                        : "text-slate-900 dark:text-white"
                    }
                    hover:bg-slate-100 dark:hover:bg-slate-700
                  `}
                >
                  {cell.day}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScheduledCampaignCalendar;